import { gql } from '@apollo/client'

const b64toBlob = (base64: string, type = 'application/octet-stream') =>
  fetch(`data:${type};base64,${base64}`).then((res) => res.blob())

const attachmentQuery = gql`
  query AttachmentDetails($id: ID!) {
    outboundMailById(id: $id) {
      attachments {
        name
        mimeType
        base64Data
      }
    }
  }
`

const openAttachment = async (apolloClient, emailId, attachment) => {
  // Assume almost always 1 attachment per email so not worried about
  // fetching specific attachments.
  const allAttachments = await apolloClient.query({
    query: attachmentQuery,
    variables: { id: emailId },
  })

  const attachmentData = allAttachments.data.outboundMailById.attachments.find((a) => a.name === attachment.name)

  const blob = await b64toBlob(attachmentData.base64Data, attachmentData.mimeType)
  const file = new Blob([blob], { type: attachmentData.mimeType })
  const fileURL = URL.createObjectURL(file)
  window.open(fileURL)
}

export default openAttachment
